export default __webpack_public_path__ + "7900570b6a31e5f286be134b7b3422af.jpg";